import { render, staticRenderFns } from "./AppLoader.vue?vue&type=template&id=bf8f927c&"
import script from "./AppLoader.vue?vue&type=script&lang=js&"
export * from "./AppLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports